import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "8:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:5": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:6": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:7": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:8": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:9": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:10": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:11": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:12": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:13": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  "8:14": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/dispersion-900.png`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
};

export default components;
